import { stateLabelsDictionary } from "@shared/constants/au-states.constant";
import { ICountryOption } from "@shared/services/countries.service";

export enum TrustStatus {
  Active,
  Inactive,
  Archived,
  Vested
}

export enum TrustType {
  Discretionary,
  Unit
}

export enum TrustSubType {
  Discretionary,                // Discretionary Trust
  DiscretionaryWithFBE,//Discretionary Trust with Foreign Beneficiary Exclusion (FBE)
  DiscretionaryCapitalReserved, // Hybrid Discretionary Trust
  DiscretionaryFullyReserved,   // Hybrid Discretionary Trust with FBE
  Fixed,                        // Fixed Unit Trust for Income Tax Purposes
  NonFixed,                     // Standard Unit Trust
  NSWLandTax,                   // NSW Land Tax Unit Trust
  Unit
}

export enum JurisdictionType {
  NSW,
  VIC,
  QLD,
  TAS,
  WA,
  SA,
  ACT,
  NT
}

export const TrustTypesLabelsDictionary: Record<TrustType, string> = {
  [TrustType.Discretionary]: 'Discretionary Trust',
  [TrustType.Unit]: 'Unit Trust',
};

export const TrustSubtypesLabelsDictionary: Record<TrustSubType, string> = {
  [TrustSubType.Discretionary]: 'Discretionary Trust',
  [TrustSubType.DiscretionaryWithFBE]: 'Discretionary Trust with Foreign Beneficiary Exclusion (FBE)',
  [TrustSubType.DiscretionaryCapitalReserved]: 'Discretionary Trust (Capital Reserved Lineal Descendant)',
  [TrustSubType.DiscretionaryFullyReserved]: 'Discretionary Trust (Fully Reserved Lineal Descendant)',
  [TrustSubType.Fixed]: 'Fixed Unit Trust',
  [TrustSubType.NSWLandTax]: 'NSW Land Tax Unit Trust',
  [TrustSubType.Unit]: 'Unit Trust',
  [TrustSubType.NonFixed]: 'Non Fixed Unit Trust',
};

export const trustTypeBySubtype: Record<TrustSubType, TrustType> = {
  [TrustSubType.Discretionary]: TrustType.Discretionary,
  [TrustSubType.DiscretionaryWithFBE]: TrustType.Discretionary,
  [TrustSubType.DiscretionaryCapitalReserved]: TrustType.Discretionary,
  [TrustSubType.DiscretionaryFullyReserved]: TrustType.Discretionary,

  [TrustSubType.Fixed]: TrustType.Unit,
  [TrustSubType.NSWLandTax]: TrustType.Unit,
  [TrustSubType.Unit]: TrustType.Unit,
  [TrustSubType.NonFixed]: TrustType.Unit,
}

export const jurisdictionOptions: ICountryOption[] = [
  JurisdictionType.NSW,
  JurisdictionType.VIC,
  JurisdictionType.QLD,
  JurisdictionType.TAS,
  JurisdictionType.WA,
  JurisdictionType.SA,
  JurisdictionType.ACT,
  JurisdictionType.NT
]
  .map((jurisdictionType) => {
    const countryCode = JurisdictionType[jurisdictionType];

    return {
      label: stateLabelsDictionary[countryCode],
      value: jurisdictionType,
      countryCode,
      flagClass: `fi fi-${ countryCode.toLowerCase() }`,
    };
  });
